import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminMenuItems from "./pages/AdminMenuItems";
import ProtectedRoute from "./components/ProtectedRoute";
import MenuPage from "./pages/MenuPage";
import MenuCategoryPage from "./pages/MenuCategoryPage";
import ReservationPage from "./pages/ReservationPage";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  const location = useLocation();

  const pageTransition = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
    transition: { duration: 0.5, ease: "easeInOut" },
  };

  return (
    <div>
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* Public Route (User Reservation Form) */}
          <Route
            path="/"
            element={
              <motion.div {...pageTransition}>
                <Home />
              </motion.div>
            }
          />

          {/* Admin Login Page */}
          <Route
            path="/admin"
            element={
              <motion.div {...pageTransition}>
                <AdminLogin />
              </motion.div>
            }
          />

          {/* Reservation Page */}
          <Route
            path="/reservation"
            element={
              <motion.div {...pageTransition}>
                <ReservationPage />
              </motion.div>
            }
          />

          {/* Menu Page */}
          <Route
            path="/menu"
            element={
              <motion.div {...pageTransition}>
                <MenuPage />
              </motion.div>
            }
          />

          {/* Menu Categories Page */}
          <Route path="/menu/:category" element={<MenuCategoryPage />} />


          {/* Admin Dashboard */}
          <Route
            path="/admin/dashboard"
            element={
              <motion.div {...pageTransition}>
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              </motion.div>
            }
          />

          {/* Admin Menu Items */}
          <Route
            path="/admin/menu"
            element={
              <motion.div {...pageTransition}>
                <ProtectedRoute>
                  <AdminMenuItems />
                </ProtectedRoute>
              </motion.div>
            }
          />
        </Routes>
      </AnimatePresence>
    </div>
  );
}
